import { type IConfig } from '@cian/config/shared';
import { useMemo } from 'react';

import { useSubsidizedMortgageOption } from './useSubsidizedMortgageOption';
import { TPromoSearchTypes } from '../../../../../../../shared/types/promoSearchTypes';
import { TJsonQuery } from '../../../../../../JsonQuery';

interface IParams {
  promoSearchTypes: TPromoSearchTypes;
  jsonQuery: TJsonQuery;
  config: IConfig;
}

export const useMortgagePromoSearchTypeOptions = ({ promoSearchTypes, jsonQuery, config }: IParams) => {
  const subsidizedMortgageOption = useSubsidizedMortgageOption({ jsonQuery, config });

  return useMemo(() => {
    if (!promoSearchTypes) {
      return [];
    }

    return [
      { label: 'Неважно', value: null },
      ...(subsidizedMortgageOption ? [subsidizedMortgageOption] : []),
      ...promoSearchTypes.mortgage.map(({ value, name: label }) => ({
        value,
        label,
      })),
    ];
  }, [promoSearchTypes, subsidizedMortgageOption]);
};
